import React from 'react';
import { t } from 'i18next';
import { Button } from '@brighterion/br-ui';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import TenantGroupOverview from 'Routes/ManageTenants/routes/TenantGroup/components/TenantGroupOverview';
import TenantGroupRulesTable from 'Routes/ManageTenants/routes/TenantGroup/components/TenantGroupRulesTable';
import useGetTenantGroupRulesColumns from 'Hooks/useGetTenantGroupRulesColumns';
import styles from './SingleTenantGroupView.css';

type SingleTenantGroupViewScheduledProps = {
    rulesData: GlobalRulesData;
    tenantGroupRevisions: GlobalRulesData[];
    currTenantGroup?: TenantGroup;
    setShowSingleTenantGroup: React.Dispatch<React.SetStateAction<boolean>>;
};

const SingleTenantGroupViewScheduled = ({
    rulesData,
    tenantGroupRevisions,
    currTenantGroup,
    setShowSingleTenantGroup
}: SingleTenantGroupViewScheduledProps) => {
    const ruleTableColumns = useGetTenantGroupRulesColumns();
    const tenantGroupRevision = tenantGroupRevisions.find((revision) => revision.id === currTenantGroup?.id);

    const redirectToTenantGroupList = () => {
        setShowSingleTenantGroup(false);
    };

    return (
        <div className={styles.rulesContainer}>
            <Button
                className={styles.tenantGroupBtn}
                variant='tertiary'
                size='small'
                iconName='arrow-left-1'
                onClick={handleOnClickEvent(redirectToTenantGroupList)}
                onKeyDown={handleKeyEvent(redirectToTenantGroupList)}
            >
                {t('Back to Tenant Groups')}
            </Button>

            {!tenantGroupRevision ? (
                <div>Not Found</div>
            ) : (
                <>
                    <TenantGroupOverview
                        ruleData={tenantGroupRevision}
                        tenantGroupId={currTenantGroup?.id?.toString() || ''}
                        tenantGroup={currTenantGroup}
                        mode='revisionWindow'
                    />
                    <div className={styles.tableContainer}>
                        <TenantGroupRulesTable
                            columnNames={ruleTableColumns}
                            globalRules={rulesData}
                            tenantOverrideRules={tenantGroupRevision}
                            mode='revisionWindow'
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default SingleTenantGroupViewScheduled;
